"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const NavigationItems = _ref => {
  let {
    categories,
    horizontalNav = true,
    onCategoriesLinkHandle,
    onHandlePageClick,
    navItemList
  } = _ref;

  const navList = () => {
    if (navItemList.length > 5) {
      const navListArr = [...navItemList];
      navListArr.length = 5;
      navListArr.push("More");
      return navListArr;
    }

    return navItemList;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "templateNavItems ".concat(horizontalNav ? "" : "vertical-nav")
  }, navItemList && navItemList.length > 0 && navList().map(item => /*#__PURE__*/_react.default.createElement("span", {
    className: "templateNavItems__item"
  }, item)));
};

var _default = NavigationItems;
exports.default = _default;